export default [
    {
        id: 1,
        descripcion: 'INVENIET'
    },
    {
        id: 2,
        descripcion: 'ORION'
    }
]